module.exports = __webpack_public_path__ + "files/824bc6b26c54d4af22198251cefeb713.svg";